/*
 * File Created: Thursday, 11th May 2023 8:28:14 pm
 * Author: Chenzier Kabrabam
 * Copyright (c) - 2018-2023 Addble Solutions Private Limited. All Rights Reserved.
 */

import TextField, { type TextFieldProps } from "@mui/material/TextField";
import React from "react";

export type InputProps = TextFieldProps;

function Input({ ...rest }: InputProps): JSX.Element {
  return (
    // <FormControl {...formControl}>
    <TextField {...rest} />
    // </FormControl>
  );
};

export default React.memo(Input);